import React from 'react';

import KnowledgeBaseContent from './components/KnowledgeBaseContent';

const KnowledgeBaseList = () => {
  return (
    <KnowledgeBaseContent />
  );
};

export default KnowledgeBaseList; 